<template>
  <div class="STree">
    <el-input
      v-if="isShowFilter"
      v-model="filterText"
      placeholder="输入关键字进行过滤"
    />
    <el-tree
      ref="tree"
      :data="data"
      show-checkbox
      node-key="id"
      :filter-node-method="filterNode"
      highlight-current
      :props="defaultProps"
      @check-change="handleCheckChange"
      empty-text=""
    />
  </div>
</template>

<script>
export default {
  name: 'STreeNew',
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    isShowFilter: {
      type: Boolean,
      default() {
        return true
      }
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    checkedType: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      filterText: '',
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    }
  },
  computed: {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    value(v, a) {
      this.setValue()
    }
  },
  created: function() {},
  mounted() {
    this.setValue()
  },
  beforeUpdate() {
    this.setValue()
  },
  methods: {
    handleCheckChange(data, checked, indeterminate) {
      const ids = this.getCheckedIds()
      this.$emit('input', ids)
    },
    getCheckedIds() {
      const ids = []
      const nodes = this.$refs.tree.getCheckedNodes(true, false)
      for (var i = 0; i < nodes.length; i++) {
        const node = nodes[i]
        if (!node.noData) {
          if (this.checkedType) {
            if (node.attrs.type === this.checkedType) {
              ids.push(node.id)
            }
          } else {
            ids.push(node.id)
          }
        }
      }
      return ids
    },
    resetChecked() {
      this.$refs.tree.setCheckedKeys([])
    },
    setValue(val) {
      let cks = val
      if (!cks) {
        const { value } = this
        cks = value
      }
      this.$refs.tree.setCheckedKeys(cks)
      this.$emit('input', cks)
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    }
  }
}
</script>

<style scoped lang="less">
@import "./index.less";
</style>



// WEBPACK FOOTER //
// src/components/StreeNew/index.vue